module.exports = __webpack_public_path__ + "static/media/nav-icon-role-relation-active.52d1ae49.svg";